(function(){
    var svgRequest = new XMLHttpRequest();
    svgRequest.open("GET", "assets/svgs/sprite.svg", true);
    svgRequest.send();
    svgRequest.onload = function(e) {
        var div = document.createElement("div");
        div.innerHTML = svgRequest.responseText;
        div.className = "visuallyhidden";
        div.setAttribute('aria-hidden', true)
        document.body.insertBefore(div, document.body.childNodes[0]);
    }
}());



(function () {
    var loadScript = function (path) {
        var a = document.createElement('script');
        var s = document.getElementsByTagName('script')[0];
        a.async = 1;
        a.src = path;
        s.parentNode.insertBefore(a, s);
    }
    var belishaUrl = window.__APP_CONFIG__.environment === 'prod'
        ? 'https://belisha.dealerauction.co.uk' : 'https://belisha-qa.dealerauction.co.uk';
    loadScript(belishaUrl + '/js/signals.js');
})();

(function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:1602350,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

// Purges all service workers configured on this page. Added due to issues seen with workers hanging around.
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        if (registrations.length) {
            for(let registration of registrations) {
                registration.unregister();
            }
        }
    });
}
